import makeApiRequest from "src/api/makeApiCall";
import { Config } from "src/latest/src/constants/AppServerConfig";

const PRACTICE_SERVICE = Config.practiceService;

export const getSearchedLocations = async (keyword: string) => {
    return await makeApiRequest(
        `${PRACTICE_SERVICE}locations/_search?keyword=${keyword}`,
        "GET"
    );
};
